import '@services/onload';

import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { PersistGate } from 'redux-persist/integration/react';

import App from '@/app/App';
import ErrorBoundaryWrapper from '@components/error/error-boundary/ErrorBoundary';
import LoadingScreen from '@components/loaders/loading-screen';
import DraggablePopupContainer, {
    DraggablePopupSecContainer,
} from '@components/widgets/draggable-popup/container';
import PopupContainer from '@components/widgets/popup/container';
import TaooToastContainer from '@components/widgets/toast/ToastContainer';
import { application_type } from '@constants/api';
import { milliSecondsToMinutes } from '@services/conversion';
import store, { persistor } from '@store/index';
import { SET_USER } from '@store/user/types';
import TaooServerClient from 'http/axios';

import { ReloadPrompt } from './app/reload';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-circular-progressbar/dist/styles.css';
import '@assets/styles/index.scss';

document.addEventListener('DOMContentLoaded', () => {
    if (localStorage[`${application_type}_user`]) {
        const user = JSON.parse(
            localStorage.getItem(`${application_type}_user`),
        );

        TaooServerClient.defaults.headers.Authorization = `Bearer ${user.token}`;
        store.dispatch({
            type: SET_USER,
            payload: user,
        });
    }

    // store onboarding state - resume paused onboarding after 1 hour
    const updateDelay = milliSecondsToMinutes(60);

    const interval = setInterval(() => {
        const state = store.getState();

        if (state.user.onboarded) {
            clearInterval(interval);
        }

        store.dispatch({ type: 'ONBOARDING_RESUME' });
    }, updateDelay);

    // store data fetching - update handling
    // const storeUpdateDelay = milliSecondsToMinutes(5);

    // setInterval(() => {
    //     store.dispatch(toggleStoreUpdate(true));
    // }, storeUpdateDelay);
});

window.addEventListener('vite:preloadError', async (event) => {
    event.preventDefault();

    const registration = await navigator.serviceWorker.getRegistration();

    if (registration) {
        await registration.update();
    }

    window.location.reload();
});

const Root = createRoot(document.getElementById('root')!);

Root.render(
    <BrowserRouter>
        {/* <React.StrictMode> */}
        <ErrorBoundaryWrapper>
            <Provider store={store}>
                {/*
                    Why use <PersistGate /> ??
                    => Delay the rendering of our app’s UI until the persisted data is available in the Redux store
                */}
                <PersistGate loading={<LoadingScreen />} persistor={persistor}>
                    <App />

                    <PopupContainer />
                    <DraggablePopupContainer />
                    <DraggablePopupSecContainer />
                    <TaooToastContainer />

                    <ReloadPrompt />
                </PersistGate>
            </Provider>
        </ErrorBoundaryWrapper>
        {/* </React.StrictMode> */}
    </BrowserRouter>,
);
